import React from "react";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";

const RankedGrossProfitSubtitle: React.FC = () => {
    const store = useAppSelector(selectStore);
    const comparator = useAppSelector(selectComparator);

    return (
        <>
            Analyse your {store?.name} store's 12-month gross profit margin and contextualise its performance
            against {comparator?.name}. Determine whether your {store?.name} store is a bottom, average, or top
            performer and where it ranks among {comparator?.name}.
        </>
    );
};

export default RankedGrossProfitSubtitle;
